import { styled } from '@mui/material';
import { TextField } from '../../../formControls/TextFieldStyled/TextField';

export const Textarea = styled(TextField)({
  '& textarea': {
    padding: '8px 11px',
  },
});
